import React, { FunctionComponent } from 'react';
import { Form, Field } from 'react-final-form';
import i18next from 'i18next';

import { requiredValidation } from 'helpers/validations';

import Input from 'components/inputs/Input';

import { ViewContainer, ViewContent, Title } from 'styles/view';
import { FormContent, FormButtonContainer, FormSubmitButton } from 'styles/form';

import { IContactViewProps } from './types';

import './i18n';

const ContactView: FunctionComponent<IContactViewProps> = ({ onSubmit, fullWidth = false }) => {
  return (
    <ViewContainer auth>
      <ViewContent auth={fullWidth}>
        <Title>{i18next.t<string>('CONTACT:TITLE', 'Nueva Consulta')}</Title>
        <Form
          onSubmit={onSubmit}
          render={({ handleSubmit, submitting, pristine }) => (
            <FormContent data-testid="login-form" onSubmit={handleSubmit}>
              <Field
                label={i18next.t<string>('CONTACT:SUBJECT')}
                name="subject"
                render={Input}
                validate={requiredValidation}
              />
              <Field
                label={i18next.t<string>('CONTACT:MESSAGE')}
                name="message"
                render={Input}
                validate={requiredValidation}
              />
              <FormButtonContainer>
                <FormSubmitButton disabled={pristine || submitting} type="submit">
                  {i18next.t<string>('CONTACT:SUBMIT_BUTTON')}
                </FormSubmitButton>
              </FormButtonContainer>
            </FormContent>
          )}
        />
      </ViewContent>
    </ViewContainer>
  );
};

export default ContactView;
